/**
 * Quem pode marcar/desmarcar uma etiqueta como privada (#1293).
 *
 * Espelho de `LabelPolicy#create_private?` e `LabelPolicy#toggle_private?`. A
 * regra do servidor continua sendo a que vale — isto so decide se o campo
 * aparece na tela, para o usuario nao preencher um formulario que vai voltar 403.
 *
 * Privar e ESCONDER, e por isso a autoria e cobrada ao ALTERAR: marcar a
 * etiqueta da equipe como privada some com ela para todo mundo, e desmarcar a
 * privada de outra pessoa expoe o que ela escondeu. Ao CRIAR nao ha o que
 * cobrar: quem cria e o autor.
 *
 * Etiqueta sem `created_by` (acervo anterior a #1293, ou autor apagado) so o
 * administrador priva — nao ha autor a quem atribuir a decisao.
 *
 * `permissions` ja vem expandido por `getUserPermissions`, entao `label_manage`
 * chega aqui como `label_private_manage`.
 */
export const canTogglePrivateLabel = ({
  permissions = [],
  userId = null,
  label = null,
} = {}) => {
  if (permissions.includes('administrator')) return true;
  if (!permissions.includes('label_private_manage')) return false;
  // Sem etiqueta = criacao.
  if (!label) return true;

  const authorId = label.created_by?.id;
  return Boolean(authorId) && Boolean(userId) && authorId === userId;
};

export default canTogglePrivateLabel;
